/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useContext, useState } from 'react';
import Context from '../context/form-context';
import { tratarRetornoCamposBackend } from '../helpers/funcoesAuxiliares';
import { editarDependenteController } from '../infraestrutura/infraestrutura';
import { useFormikContext } from 'formik';
import { categoriaBodyTemplate, parentescoBodyTemplate } from './FormValor';
import { showMessageSuccess } from '../../others/toastr';
import Swal from 'sweetalert2';
import { validateDependentes } from './ValidarDependentesUpSell';
import { mensagemSweetAlertWarning } from '../../upSell/funcoesUpSell';

export const DataTableDependentesUpSell = ({ carregarCamposFormulario, estaSubmetendo }) => {
    const [dependenteSelecionado, setDependenteSelecionado] = useState(null);
    const { setSubmitting, resetForm } = useFormikContext();
    const { state, setState } = useContext(Context);
    const { editar, dependentes, subGrupoSelecionadoUpSell } = state;

    const { dependentesAtivos, dependentesInativos } = dependentes.reduce(
        (acc, dep) => {            
            if (dep.Status) {
                acc.dependentesAtivos.push(dep);
            } else {
                acc.dependentesInativos.push(dep);
            }

            return acc;
        },
        { dependentesAtivos: [],
            dependentesInativos: [] }
    );

    const scrollToForm = () => {
        const nome = document.getElementById('Nome');

        nome.scrollIntoView({
            behavior: 'smooth',
            inline: 'nearest',
            block: 'center'
        });
        setTimeout(() => nome.focus(), 1000);
    };

    const tratarDadosEdicaoRowData = rowData => {
        const {
            Seq,
            Nome,
            CPF,
            Telefone,
            Email,
            DepSexo,
            ['CategoriaParentesco.Categoria']: Categoria,
            ['GrauParentesco.Grau']: ParentescoValue,
            Parentesco: ParentescoUpSell,
            Categoria: CategoriaUpSell,
            Idade,
            Nascimento: nascimentoLinha,
            CaracteristicasPet,
            PesoPet,
            TipoPet,
            CorPet,
            Porte,
            ['Associado.Plano']: Plano,
            valor: ValorDependente,
            Status
        } = rowData;

        const [dia, mes, ano] = nascimentoLinha.split('/');
        const dataTratada = new Date(ano, mes - 1, dia);

        return tratarRetornoCamposBackend({
            Seq,
            Nome,
            Telefone,
            CPF,
            Email,
            DepSexo,
            Categoria: Categoria ?? CategoriaUpSell,
            Parentesco: ParentescoValue?.trim() ?? ParentescoUpSell?.trim(),
            Idade,
            Nascimento: nascimentoLinha === '' ? null : dataTratada,
            CaracteristicasPet,
            PesoPet,
            TipoPet,
            CorPet,
            Porte,
            Plano: Plano?.trim(),
            ValorDependente,
            Status
        });
    };

    const handleEdit = rowData => {
        const objEdicaoSemNulos = tratarDadosEdicaoRowData(rowData);

        setState({
            ...state,
            arrayMsgsValidacoesPlano: [],
            objComparadorEdicao: objEdicaoSemNulos
        });
        carregarCamposFormulario(objEdicaoSemNulos);

        if (!editar) {
            setState({
                ...state,
                arrayMsgsValidacoesPlano: [],
                objComparadorEdicao: objEdicaoSemNulos,
                editar: true
            });
        }

        scrollToForm();
    };

    const handleAtivarDesativarDep = async rowData => {
        setSubmitting(true);
    
        const { Status, Inscricao, Seq } = rowData;
        let ativacaoDep = true;
        let msgTitle = 'Confirmação de Ativação';
        let msgText = 'Deseja ativar este dependente?';
        let msgSucesso = 'Dependente Ativado com sucesso!';
    
        if (Status) {
            msgTitle = 'Deseja inativar este dependente?';
            msgText = 'Caso seja inativado, apos o aceite este dependente não terá direito aos benefícios do plano.';
            msgSucesso = 'Dependente Inativado com sucesso!';
            ativacaoDep = false;
        }
    
        const result = await Swal.fire({
            title: msgTitle,
            text: msgText,
            showCancelButton: true,
            confirmButtonColor: '#0d730d',
            cancelButtonColor: '#1b42cd',
            cancelButtonText: 'Não',
            confirmButtonText: 'Sim'
        });
    
        if (result.isConfirmed) {
            rowData.Status = !Status;
    
            const body = tratarDadosEdicaoRowData(rowData);
    
            if (ativacaoDep) {
                const msgsErro = validateDependentes(dependentesAtivos, state?.plano?.trim());
    
                if (msgsErro.length > 0) {
                    rowData.Status = Status;
                    mensagemSweetAlertWarning(msgsErro[0]);
                    setSubmitting(false);

                    return;
                }
            }
    
            await editarDependenteController(body, Inscricao, subGrupoSelecionadoUpSell, Seq);
            resetForm();
            setState({
                ...state,
                dependentes: [],
                arrayMsgsValidacoesPlano: [],
                recarregarTabelaDependentes: true
            });
            setSubmitting(false);
            showMessageSuccess('Sucesso', msgSucesso, 'toast-top-center');
        }
    
        setSubmitting(false);
    };

    const acoesDeManutencaoDependente = (rowData, ativado) => {
        let desabledEdicao = estaSubmetendo;

        if (subGrupoSelecionadoUpSell) {
            if (!rowData?.Status) {
                desabledEdicao = true;
            }
        }

        const handleToggleChange = async () => {
            await handleAtivarDesativarDep(rowData);
        };

        return (
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                    <Button
                        label="Editar"
                        type="button"
                        iconPos="left"
                        className="p-button-success"
                        disabled={desabledEdicao}
                        onClick={() => {
                            handleEdit(rowData);
                        }}
                    />
                </div>
                <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                    {ativado ? (
                        <Button
                            label="Inativar"
                            iconPos="left"
                            className="p-button-danger"
                            disabled={estaSubmetendo}
                            type="button"
                            onClick={handleToggleChange}
                        />
                    ) : (
                        <Button
                            label="Ativar"
                            iconPos="left"
                            className="p-button-primary"
                            disabled={estaSubmetendo}
                            type="button"
                            onClick={handleToggleChange}
                        />
                    )}
                </div>
            </div>
        );
    };

    const renderDataTable = (data, ativado) => (
        <DataTable
            dataKey="Seq"
            selection={dependenteSelecionado}
            onSelectionChange={e => setDependenteSelecionado(e.value)}
            autoLayout
            style={{ textAlign: 'center' }}
            value={data}
            paginator={false}
            sortField="data"
            loading={estaSubmetendo}
            loadingIcon='pi pi-spin pi-spinner'
            sortOrder={1}
        >
            <Column field="Seq" header="Seq" />
            <Column field="Nome" header="Nome" />
            <Column field={['CategoriaParentesco.Descricao']} header="Categoria" body={categoriaBodyTemplate} />
            <Column field="Parentesco" header="Parentesco" body={parentescoBodyTemplate} />
            <Column field="Nascimento" header="Nascimento" />
            <Column field="valor" header="Valor" body={rowData => new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(rowData.valor)} />
            <Column
                header="Ações"
                body={rowData => acoesDeManutencaoDependente(rowData, ativado)}
                headerStyle={{
                    width: '14em',
                    textAlign: 'center'
                }}
                bodyStyle={{
                    textAlign: 'center',
                    overflow: 'visible'
                }}
            />
        </DataTable>
    );

    const styles = {
        warningMessage: {
            color: 'red',
            display: 'flex',
            marginTop: '10px',
            justifyContent: 'center'
        }
    };

    return (
        <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-12">
                <h1>Dependentes Ativos:</h1>
                {renderDataTable(dependentesAtivos, true)}
            </div>
            {dependentesInativos.length > 0 && (
                <div className="p-col-12 p-md-12">
                    <div style={styles.warningMessage}>
                        <i className="pi pi-exclamation-triangle" style={{ marginRight: '.5em' }}></i>
                        Os dependentes que estiverem na tabela abaixo serão inativados após aceite.
                    </div> 
                    <h1>Dependentes Inativos:</h1>
                    {renderDataTable(dependentesInativos, false)}
                </div>
            )}
        </div>
    );
};